import { render, staticRenderFns } from "./DownloadAnnotationsModal.vue?vue&type=template&id=46357606&scoped=true"
import script from "./DownloadAnnotationsModal.vue?vue&type=script&lang=js"
export * from "./DownloadAnnotationsModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadAnnotationsModal.vue?vue&type=style&index=0&id=46357606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46357606",
  null
  
)

export default component.exports